import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-youtube",
  "use": "icon-youtube-usage",
  "viewBox": "0 0 18 13",
  "content": "<symbol viewBox=\"0 0 18 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-youtube\"><path d=\"M9.098 12.573a8.88 8.88 0 0 1-.196 0c-8.266-.005-8.87-.377-8.9-5.95C0 6.594 0 6.563 0 6.53a132.164 132.164 0 0 1 .001-.58C.032.376.636.004 8.901 0a8.88 8.88 0 0 1 .197 0c8.266.005 8.87.377 8.9 5.95.002.03.002.061.002.093a132.173 132.173 0 0 1-.001.58c-.031 5.573-.635 5.945-8.9 5.95zM7.255 3.43v5.64l5.442-2.986L7.255 3.43z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol